export const getOrderByFromTable = sorter => {
  if (!sorter || !sorter?.field) {
    return undefined;
  }

  const direction = sorter.order === 'descend' ? 'DESC' : 'ASC';

  return `${sorter.field}_${direction}`;
};
